import { Injectable } from '@angular/core';
import { LoggingService } from './logging/logging.service';
import { LoggingConstants } from './../constants/logging-constant';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ThriveCommonService {

    configurations: any;
    primarynavData: Array<any>;
    renderedLogDetails: Array<any> = [];
    totalNumberOfWidgets: number = 0;
    numberOfWidgetLoaded: number = 0;
    dcpreferenceData: any = {
        'widgetInstanceIdentifier': 'ThriveHomePage_DC_PinnedItems',
        'preferences': {
            'datacards': {
                'name': 'datacards',
                'values': []
            }
        }
    };
    private componentDetails = new BehaviorSubject({});
    componentData = this.componentDetails.asObservable();

    constructor(private loggingService: LoggingService) { }

    setConfiguration(config: any) {
        this.configurations = config;
    }

    setDcPreferenceData(preferenceData: any) {
        this.dcpreferenceData = preferenceData;
    }
     /* istanbul ignore next */
    setpinPreferenceDCExist(pinexist) {
        this.configurations['pinPreferenceDCExist'] = pinexist;
    }
     /* istanbul ignore next */
    getDcPreferenceData() {
        return this.dcpreferenceData;
    }
     /* istanbul ignore next */
    getConfiguration() {
        return this.configurations;
    }

    setPrimarynavData(data: Array<any>) {
        this.primarynavData = data;
    }

    getPrimarynavData() {
        return this.primarynavData;
    }
    /* istanbul ignore next */
    registerWidget() {
        this.totalNumberOfWidgets++;
    }
    /* istanbul ignore next */
    getTotalWidgetCount() {
        return this.totalNumberOfWidgets;
    }
    /* istanbul ignore next */
    updateWidgetLoaded() {
        this.numberOfWidgetLoaded++;
    }
    /* istanbul ignore next */
    getNumberOfWidgetLoaded() {
        return this.numberOfWidgetLoaded;
    }
    /* istanbul ignore next */
    setRenderedLogData(addLogData: Array<any>, setWidgetCount) {
        this.renderedLogDetails.push(addLogData);
        if (setWidgetCount) {
            this.updateWidgetLoaded();
        }
    }
    /* istanbul ignore next */
    getRenderedLogData() {
        return this.renderedLogDetails;
    }
    /* istanbul ignore next */
    clearRenderedLogData() {
        this.renderedLogDetails = [];
    }
    /* istanbul ignore next */
    getLinkType(linkOnClick) {
        if (linkOnClick !== null &&
            linkOnClick !== undefined && linkOnClick.indexOf('External Link') !== -1) {
            return 'EXTERNAL_LINK';
        }
        return 'INTERNAL_LINK';
    }
    /* istanbul ignore next */
    logRenderedWidgetDetails() {
        try {
            let counter = 0;
            let totalWidgetCount = 0;
            let widgetLoadedCount = 0;
            let pageName = '';
            const pathArray = window.location.href.split('/');
            if (pathArray && pathArray.length > 0) {
                pageName = pathArray[pathArray.length - 1];
            }
            let checkWidgetLoaded = setInterval(() => {
                totalWidgetCount = this.getTotalWidgetCount();
                widgetLoadedCount = this.getNumberOfWidgetLoaded();
                if (totalWidgetCount === 0 && counter <= 10) {
                } else if (totalWidgetCount === widgetLoadedCount) {
                    if (totalWidgetCount !== 0) {
                        this.loggingService._uxRenderEvent(this.getRenderedLogData(),
                            'Page - ' + pageName, '', 'Render', LoggingConstants.GLOBAL_PAGE_USAGE_LEVEL_SEVERITY);
                        this.clearRenderedLogData();
                    }
                    this.clearRenderedLogData();
                    totalWidgetCount = 0;
                    widgetLoadedCount = 0;
                    clearInterval(checkWidgetLoaded);
                }
                if (counter > 30) {
                    clearInterval(checkWidgetLoaded);
                }
                counter++;
            }, 1000);
        } catch (error) {
        }
    }

    /* istanbul ignore next */
    updateComponentData(data: string) {
        this.componentDetails.next(data);
    }

    /* istanbul ignore next */
    clearComponentData() {
        this.componentDetails = new BehaviorSubject(null);
    }
}
